import type { SystemConfig } from '@/types/system-config';

export const getSystemConfigString = (
  config: SystemConfig | undefined,
  key: string,
): string | undefined => {
  const value = config?.[key];
  if (value == null) return undefined;
  return String(value);
};

export const getSystemConfigNumber = (
  config: SystemConfig | undefined,
  key: string,
  fallback = 0,
): number => {
  const raw = getSystemConfigString(config, key);
  if (raw == null) return fallback;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getSystemConfigList = (config: SystemConfig | undefined, key: string): string[] => {
  const value = config?.[key];
  if (Array.isArray(value)) {
    return value.map(String);
  }
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value) as unknown;
      if (Array.isArray(parsed)) return parsed.map(String);
    } catch {
      return [];
    }
  }
  return [];
};

export const getSystemConfigJson = <T>(
  config: SystemConfig | undefined,
  key: string,
): T | undefined => {
  const value = config?.[key];
  if (value == null) return undefined;
  if (typeof value === 'object' && !Array.isArray(value)) {
    return value as T;
  }
  if (typeof value === 'string') {
    try {
      return JSON.parse(value) as T;
    } catch {
      return undefined;
    }
  }
  return undefined;
};
